import { useController, Control, FieldValues, Path } from "react-hook-form";
import { twMerge } from "tailwind-merge";

import Label from "@/components/form-controls/Label";
import PhoneInput from "react-phone-number-input";

import "react-phone-number-input/style.css";

export type PhoneInputProps<T extends FieldValues> = React.ComponentProps<"input"> & {
    name: Path<T>
    label?: string,
    labelStyle?: string,
    hint?: string
    control?: Control<T>
}


const PhoneNumberInput = <T extends FieldValues>(props: PhoneInputProps<T>) => {
    const {
        field,
        fieldState: { isDirty, error },
    } = useController({
        name: props.name ?? "phone-input",
        control: props.control,
    });

    return (
        <div className={props.className}>
            <Label 
                name={props.name ?? ""} 
                text={props.label} 
                required={props.required}
                className={props.labelStyle}
                hint={props.hint}
            />

            <div className="relative">
                <PhoneInput
                    placeholder="enter phone number"
                    className={twMerge(
                        "input", 
                        isDirty ? "input-error" : "input-default",
                        props.prefix ? "pl-12" : "",
                        (props.disabled || props.readOnly) && "bg-primary-100",
                    )}
                    value={field.value}
                    name={field.name}
                    inputRef={field.ref} 
                    onBlur={field.onBlur}
                    onChange={(value) => field.onChange(value)} 
                    required={props.required}
                />

                {
                    error &&
                    <div className="text-xs text-rose-800 font-medium px-1 pt-1">
                        { error ? error.message : "field is required" }
                    </div>
                }
            </div>
            
        </div>
    )
}

export default PhoneNumberInput